import { render } from "./TicketsView.vue?vue&type=template&id=b6ec87cc&scoped=true"
import script from "./TicketsView.vue?vue&type=script&lang=js"
export * from "./TicketsView.vue?vue&type=script&lang=js"

import "./TicketsView.vue?vue&type=style&index=0&id=b6ec87cc&scoped=true&lang=css"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6ec87cc"]])

export default __exports__